import { render, staticRenderFns } from "./DescargaDatosProperties.vue?vue&type=template&id=8d446d60&scoped=true"
import script from "./DescargaDatosProperties.vue?vue&type=script&lang=js"
export * from "./DescargaDatosProperties.vue?vue&type=script&lang=js"
import style0 from "./DescargaDatosProperties.vue?vue&type=style&index=0&id=8d446d60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d446d60",
  null
  
)

export default component.exports